import { useContext } from 'react';

import QrsContext from './QrsContext';

const useQrs = () => {
  const context = useContext(QrsContext);
  if (context === null) {
    throw new Error('useQrs must be used within a QrsProvider');
  }
  return context;
};

export default useQrs;
